import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import HowItWorks from "@/components/HowItWorks";
import About from "@/components/About";
import ServiceArea from "@/components/ServiceArea";
import Fleet from "@/components/Fleet";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Faq from "@/components/Faq";
import QuoteForm from "@/components/QuoteForm";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import MobileActionBar from "@/components/MobileActionBar";
import { scrollToId } from "@/data/site";
import { useSeo } from "@/hooks/useSeo";

const Home = () => {
  const location = useLocation();

  useSeo({
    title: "Freedom Mobile Auto Detailing | Mobile Car Detailing in Gap PA",
    description:
      "Mobile auto detailing in Gap, Paradise, Parkesburg & nearby Lancaster and Chester County, PA towns. Interior + exterior detailing at your location. Cars from $120. Free quote.",
    path: "/",
  });

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const t = setTimeout(() => scrollToId(id), 200);
      return () => clearTimeout(t);
    }
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [location.state]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Marquee />
        <Services />
        <Pricing />
        <HowItWorks />
        <About />
        <ServiceArea />
        <Fleet />
        <Gallery />
        <Reviews />
        <Faq />
        <QuoteForm />
        <FinalCta />
      </main>
      <Footer />
      <div className="h-14 lg:hidden" aria-hidden="true" />
      <MobileActionBar />
    </>
  );
};

export default Home;
